const GET_USER_DETAIL = 'GET_USER_DETAIL'
const GET_USER_DETAIL_SUCCESS = 'GET_USER_DETAIL_SUCCESS'
const GET_USER_DETAIL_RESET = 'GET_USER_DETAIL_RESET'

export { GET_USER_DETAIL, GET_USER_DETAIL_SUCCESS, GET_USER_DETAIL_RESET }
